import * as types from './tokenActionTypes';

const initialState = {
  buyTokenModal: false
  }

export const tokenReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.BUY_TOKEN_MODAL:
      return {
        ...state,

        buyTokenModal: action?.payload,
      };
    default:
      return state;
  }
};
